import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import { Button } from "../../Components/Common/Tailwind";
import { useAuthContext } from "../../Components/AuthContext";
import { LoginTitleImgModal } from "../../Components/modal/ManagerModal";
import { useUserStore } from "../../store/store";

import { authService } from "../../api/services/auth.service";
import { KAKAO_AUTH_URL } from "../../api/auth";
import MobileViewContainer from "../../Components/MobileViewContainer";

// const NAVER_AUTH_URL = `https://nid.naver.com/oauth2.0/authorize?response_type=code&client_id=${CLIENT_ID}&state=${STATE_STRING}&redirect_uri=${CALLBACK_URL}`;

const Login = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isUserLogin, isLoading, error } = useAuthContext();

  /* 값을 index의 permission을 navbar를 통해 가지고 옴 */
  const [permission, setPermission] = React.useState(location.state ? location.state.citation : 0);
  const [loginTitleEditModal, setLoginTitleEditModal] = React.useState(false);

  const [site] = useUserStore((state) => [state.site]);

  const params = new URLSearchParams(location.search);
  const path = params.get("path");

  if (path) {
    window.localStorage.setItem("redirectTo", `${path}`);
    console.log("path", path);
  } else {
    if (window.localStorage.getItem("redirectTo")) {
      window.localStorage.removeItem("redirectTo");
    }
  }


  React.useEffect(() => {
    // 이미 로그인한 상태에서 잘못된 접근을 막는 코드
    if (isUserLogin && permission <= 1) {
      navigate(`/`);
    }
  }, [permission]);

  const handlingUnlinkKakao = async () => {
    try {
      await authService.unlinkKakaoAccount();
      // ...rest of unlink handling...
    } catch (error) {
      console.log(error);
    }
  }

  const handleKakaoLogin = async () => {
    try {
      window.location.replace(KAKAO_AUTH_URL);
    } catch (error) {
      console.error("Kakao login error:", error);
    }
  };

  return (
    <React.Fragment>
      <MobileViewContainer>
        <div className="flex h-screen items-center justify-center">
          <div className="flex flex-col items-center justify-center">
            {/* Top Section: Logo & Welcome */}
            <div className="w-full mt-5 px-4 text-center">
              <div className="mb-4 flex justify-center">
                <Link to="/" className="inline-block">
                  <img
                    src={site?.logo ? site.logo : `/amazing-logo.png`}
                    alt="Logo"
                    className="rounded-full"
                    style={{
                      height: "72px",
                      width: "auto",
                      maxWidth: "100%",
                      objectFit: "contain",
                      filter: "drop-shadow(0px 4px 12px rgba(0,0,0,0.08))"
                    }}
                  />
                </Link>
              </div>
              <h2 className="font-bold mb-2 text-center" style={{ color: "#1A1A1A", fontSize: "22px", letterSpacing: "-1px" }}>
                {site?.name || "어메이징 BBQ"}
              </h2>
              <p className="text-gray-500 mb-0 text-center" style={{ fontSize: "16px", fontWeight: "400", opacity: 0.8 }}>
                {site?.slogan || "세상에 없던 놀이터, 놀다 지쳐 쓰러지리라!"}
              </p>
            </div>

            {/* Middle Section: Social Login */}
            <div className="w-full px-4 mb-auto mt-5 pt-4">
              <div className="text-center mb-4 flex items-center justify-center">
                <div style={{ flex: 1, height: "1px", backgroundColor: "#EEE" }}></div>
                <span className="text-sm text-gray-400 px-4">
                  간편 로그인
                </span>
                <div style={{ flex: 1, height: "1px", backgroundColor: "#EEE" }}></div>
              </div>

              <button
                type="button"
                className="w-full border-0 flex items-center justify-center"
                style={{
                  backgroundColor: "#FEE500",
                  color: "#000000",
                  borderRadius: "12px",
                  height: "54px",
                  fontWeight: "600",
                  fontSize: "17px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                  gap: "10px"
                }}
                onClick={handleKakaoLogin}
                disabled={isLoading}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M12 4C7.58172 4 4 6.71066 4 10.0548C4 12.1158 5.41209 13.9299 7.55039 15.011L6.65089 18.3115C6.60623 18.4754 6.69668 18.6465 6.85292 18.6938C6.91139 18.7115 6.97375 18.71 7.03126 18.6896L10.8354 16.147C11.218 16.1882 11.6053 16.2096 12 16.2096C16.4183 16.2096 20 13.4989 20 10.1548C20 6.81066 16.4183 4 12 4Z" fill="black" />
                </svg>
                <span>카카오 로그인</span>
              </button>

              <p className="text-center mt-3 text-xs text-gray-400">
                로그인 시 이용약관 및 개인정보처리방침에 동의하게 됩니다.
              </p>
            </div>

            {/* Bottom Section: Admin & Edit */}
            <div
              className="absolute bottom-5 right-5 flex flex-col items-end z-10"
            >
              {/* 결정 459(B): 손님 로그인 화면은 카카오 버튼 하나만 — 관리자는 /admin-login 주소로 직접 */}

              {!!permission && permission >= 2 && (
                <div className="mt-1">
                  <Button
                    color="link"
                    className="no-underline text-gray-500 p-0 text-xs"
                    style={{ color: "#999999" }}
                    onClick={() => setLoginTitleEditModal(!loginTitleEditModal)}
                  >
                    이미지 수정
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
        <LoginTitleImgModal setVisible={setLoginTitleEditModal} visible={loginTitleEditModal} />
      </MobileViewContainer>
    </React.Fragment >
  );
};

export default Login;
